import Crud from '../views/User/Crud'
import Entity from '../views/User/Add'

let routes = {
    path: '/users',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/users/add',
            name: 'NewUser',
            component: Entity,
            meta: {                
                perfil_id: ['1']
            },
        },
        {
            path: '/users/edit/:id?',
            name: 'EditUser',
            component: Entity,
            meta: {                
                perfil_id: ['1']
            },
        },
        {
            path: '/users',
            name: 'list-users',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Usuários',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: true,
                    },
                ],                
                perfil_id: ['1']
            },
        },
    ]
};


export default routes
